module.exports = __webpack_public_path__ + "static/img/mood13.8a00913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood13.png
// module id = ouLl
// module chunks = 1